// Module
var code = "<script id=\"wcc-components-wcc-upload\" type=\"text/template\">\r\n    <!-- ko with: controlsConfig -->\r\n    <attachment-controls params=\"model: $data\">\r\n        <!-- ko customElement: $component.layoutConfig --><!-- /ko -->\r\n    </attachment-controls>\r\n    <!-- /ko -->\r\n</script>";
// Exports
module.exports = code;